import React__default from 'react';
import { PaginatedTableCore } from '../shared/components/PaginatedTable.mjs';
import { Table } from './Table.mjs';
import { Typography } from './Typography.mjs';
import tablePaginationClasses from '../../../../../node_modules/@mui/material/TablePagination/tablePaginationClasses.mjs';
import iconButtonClasses from '../../../../../node_modules/@mui/material/IconButton/iconButtonClasses.mjs';

const tablePaginationSx = {
    [`.${tablePaginationClasses.toolbar}`]: {
        color: (theme)=>theme.styleConfig.colors.primary
    },
    [`.${tablePaginationClasses.selectIcon}`]: {
        color: (theme)=>theme.styleConfig.colors.primary
    },
    [`.${tablePaginationClasses.actions} .${iconButtonClasses.disabled}`]: {
        color: (theme)=>theme.styleConfig.colors.secondary
    }
};
const PaginatedTable = (props)=>{
    return /*#__PURE__*/ React__default.createElement(PaginatedTableCore, {
        ...props,
        keepConsistentContentHeight: false,
        TableComponent: Table,
        TypographyComponent: Typography,
        tablePaginationSx: tablePaginationSx
    });
};

export { PaginatedTable };
//# sourceMappingURL=PaginatedTable.mjs.map
